/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
export const RESOURCE_KEY = 'nbt-opt-in-resource-key'; // value is global for user

export const STORE_KEY = 'next-best-task-feature';

export const PACKAGE_NAME = 'jiraRouterResourcesNextBestTask';

export const ANALYTICS_ID = 'useResource.fetchNextBestTaskOptInPreference';
